import { authGet } from "@api/auth/auth";
import { FetchDemoFindingsResponse, OrgData } from "@types";

export const fetchDeploymentDemoFindings = (
  org: OrgData
): Promise<FetchDemoFindingsResponse> => {
  return authGet<FetchDemoFindingsResponse>(
    `/api/agent/deployments/${org.id}/demo_issues`
  );
};
